import { render, staticRenderFns } from "./CommonWritePaResult.vue?vue&type=template&id=46a7b812&scoped=true"
import script from "./CommonWritePaResult.vue?vue&type=script&lang=js"
export * from "./CommonWritePaResult.vue?vue&type=script&lang=js"
import style0 from "./CommonWritePaResult.vue?vue&type=style&index=0&id=46a7b812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a7b812",
  null
  
)

export default component.exports